import React from 'react';
import { formatCurrency } from '@shared/formatCurrency';

interface QuotePriceDisplayProps {
  price: number;
  fundingOption?: string;
  label?: string;
  className?: string;
}

/**
 * Reusable component for displaying quote price information
 * Used in quote cards to show cost and funding details
 */
export function QuotePriceDisplay({
  price,
  fundingOption,
  label = 'Cost',
  className = 'mr-8',
}: QuotePriceDisplayProps) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-primary-dark text-sm font-medium">
        {label}
      </div>
      <div data-testid='quote-card-cost-display' className="text-primary-dark flex items-center gap-1 text-base font-semibold sm:text-lg">
        {formatCurrency(price)}
      </div>
      {fundingOption && (
        <div className="text-primary-dark text-sm font-medium italic">
          {fundingOption}
        </div>
      )}
    </div>
  );
}